import React, { useState } from "react";
import { Select } from "antd";
import { Button, Message, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { SketchPicker } from "react-color";
import { getListStructure } from "services/api/Api";
import { useIntl } from "react-intl";

const { Option } = Select;

const SummaryHoppsSettings = (props) => {
   const { value, columns } = props;
   const intl = useIntl();

   const dispatch = useDispatch();

   const [settings, setSettings] = useState({
      ...value,
      columns: columns
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChangeList = (e) => {
      getListStructure(settings.listId).then((res) => {
         const responseData = res.data.getStructure;
         if (responseData.columns) {
            setSettings({
               ...settings,
               columns: responseData.columns
            });
         }
      });
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };
   const handleChangeInput = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const handleDefaultColor = (e) => {
      setSettings({ ...settings, textColor: "#000" });
   };

   const [displayColorPickerText, setDisplayColorPickerText] = useState(false);

   const handleClick = (e) => {
      setDisplayColorPickerText(!displayColorPickerText);
   };

   const handleChangeColor = (name) => (color) => {
      setSettings({ ...value, [name]: color.hex });
   };

   const options =
      settings && settings.columns != null
         ? settings.columns.map((col) => (
              <Option key={col.label} value={col.label}>
                 {col.label}
              </Option>
           ))
         : null;

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label className="widget-settings__inner__label" key="title">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listId"
                           defaultValue={value.listId}
                           onChange={handleChange}
                           style={{ width: "100px" }}
                        />
                        <Button className="gx-ml-1" buttonType="primary" onClick={handleChangeList}>
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="columnToDisplayHopps">
                     <IntlMessages id="settings.columnToDisplayHopps" />:
                     <Select
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayHopps")}
                        defaultValue={
                           settings.columnToDisplayHopps !== null
                              ? settings.columnToDisplayHopps
                              : "----Select----"
                        }
                     >
                        {options}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="columnToDisplayPosition">
                     <IntlMessages id="settings.columnToDisplayPosition" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPosition !== null
                              ? settings.columnToDisplayPosition
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayPosition")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="columnToDisplayLevel">
                     <IntlMessages id="settings.columnToDisplayRanking" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayLevel !== null
                              ? settings.columnToDisplayLevel
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayLevel")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="columnToDisplayPoints">
                     <IntlMessages id="settings.columnToDisplayPoints" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPoints !== null
                              ? settings.columnToDisplayPoints
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayPoints")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="columnToDisplayLeftPoints">
                     <IntlMessages id="settings.columnToDisplayLeftPoints" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayLeftPoints !== null
                              ? settings.columnToDisplayLeftPoints
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayLeftPoints")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="columnToCalculateTimeline">
                     <IntlMessages id="settings.columnToCalculateTimeline" />:
                     <Select
                        defaultValue={
                           settings.columnToCalculateTimeline !== null
                              ? settings.columnToCalculateTimeline
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToCalculateTimeline")}
                     >
                        {options}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="textColor">
                     <IntlMessages id="settings.textColor" />:
                     <div>
                        <Button
                           value="textColor"
                           onClick={handleClick}
                           className="cp-color"
                           style={{
                              backgroundColor: settings.textColor
                           }}
                        >
                           <IntlMessages id="settings.clickToChangeColor" />
                        </Button>
                        <Button value="textColor" onClick={handleDefaultColor}>
                           <IntlMessages id="settings.setDefaultColor" />
                        </Button>
                        {displayColorPickerText ? (
                           <div className="cp-popover">
                              <div className="cp-cover" />
                              <SketchPicker
                                 color={settings.textColor}
                                 onChange={handleChangeColor("textColor")}
                              />
                           </div>
                        ) : null}
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="timelineListId">
                     <IntlMessages id="settings.timelineListId" />:
                     <Input
                        type="text"
                        name="timelineListId"
                        defaultValue={value.timelineListId}
                        onChange={handleChange}
                        style={{ width: 220 }}
                     ></Input>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="redirectUrl">
                     <IntlMessages id="settings.redirectUrl" />:
                     <Input
                        type="text"
                        name="redirectUrl"
                        defaultValue={value.redirectUrl}
                        onChange={handleChange}
                        style={{ width: 220 }}
                     ></Input>
                  </label>{" "}
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default SummaryHoppsSettings;
